import { getDefaultExportFromCjs as r } from "./index.es13.js";
import { __require as t } from "./index.es21.js";
var e = t();
const s = /* @__PURE__ */ r(e);
export {
  s as default,
  e as l
};
//# sourceMappingURL=index.es7.js.map
